import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'

import * as serviceWorker from './serviceWorker'

import './styles/index.scss'

import renderHeader from './utils/renderHeader'
import onAttributeChange from './utils/onAttributeChange'

import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { launchDarklyConfig } from 'data/launchDarklyConfig'

const rootNode = document.getElementById('medicare-header-root') || document.getElementById('root');

(async () => {
  // Cast to React.FC due to typing difference between React 17 and 18. In newer versions the children type within FC changed
  const LDProvider = await asyncWithLDProvider(launchDarklyConfig) as React.FC
  renderHeader(rootNode, LDProvider)
  onAttributeChange(rootNode, () => {
    renderHeader(rootNode, LDProvider)
  })
  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
    const axe = require('@axe-core/react')
    axe(React, ReactDOM, 1001, {})
  }
})()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
